import { CreateInteractionRequest } from '@/api/requests/interaction/create-interaction-request';
import { UpdateInteractionRequest } from '@/api/requests/interaction/update-interaction-request';
import { Interaction } from '@/shared/interaction';
import { Api } from './api';

export class InteractionApi extends Api {
    public async getInteractionByIdAsync(interactionId: string): Promise<Interaction> {
        return await this.getAsync(`v1/interaction/${interactionId}`);
    }

    public async createInteractionAsync(request: CreateInteractionRequest): Promise<string> {
        const url = this.buildUrl(`v1/interaction`);
        const location = await this.postAsync<string>(`v1/interaction`, request);
        return location.replace(`${url}/`, ``);
    }

    public async updateInteractionAsync(interactionId: string, request: UpdateInteractionRequest): Promise<string> {
        const url = this.buildUrl(`v1/interaction/${interactionId}`);
        const location = await this.putAsync<string>(`v1/interaction/${interactionId}`, request);
        return location.replace(`${url}/`, ``);
    }

    public async deleteInteractionAsync(interactionId: string): Promise<string> {
        const url = this.buildUrl(`v1/interaction/${interactionId}`);
        const location = await this.deleteAsync<string>(`v1/interaction/${interactionId}`);
        return location.replace(`${url}/`, ``);
    }

    public constructor() {
        super();
    }
}
